import {Component, Output, EventEmitter, Input} from '@angular/core';
import {AuditFilter} from "../audit-filter";

@Component({
    selector: 'audit-filter',
    providers: [],
    templateUrl: 'audit-filter.component.html'
})

export class AuditFilterComponent {
    model = new AuditFilter();

    @Output() filter:EventEmitter<AuditFilter> = new EventEmitter<AuditFilter>();
    @Output() export:EventEmitter<AuditFilter> = new EventEmitter<AuditFilter>();
    @Input() actions:string[];

    filterAudit() {
        this.filter.next(this.model);
    }

    exportAudit() {
        this.export.next(this.model);
    }

    get diagnostic() {
        return JSON.stringify(this.model);
    }

}





// WEBPACK FOOTER //
// ./public/upgrade/feature/audit/audit-filter/audit-filter.component.ts